module.exports = __webpack_public_path__ + "static/media/severity1.17a35e98.png";